import React, { useEffect, useState } from "react";
import { Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEdicionSocio } from "../../../../context/socio/use-edicion-socio";
import EndPoints from "../../../../utils/services/EndPoints";
import Api from "../../../../utils/services/Api";
import AgregarActividadSection from "./AgregarActividadSection";
import ListaActividades from "./ListaActividades";
import { getCodigoIfip } from "../../../../utils/Common";
import { useNavigate } from "react-router";
import { LoadingButton } from "@mui/lab";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { useSnackbar } from "notistack";
import { downloadBase64PDF } from "utils/utils";

const useStyles = makeStyles(() => ({
  cardActions: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const ActividadEconomica = () => {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const {
    infoSocio: {
      datosBasicosMs: {
        codigoPersona
      }
    },
    goPreviousStep,
  } = useEdicionSocio()
  const classes = useStyles();
  const [isSaving, setIsSaving] = useState(false)
  const [loading, setLoading] = useState(true)
  const [actividades, setActividades] = useState([])

  const getListaActividades = async () => {
    setLoading(true)
    try {
      const response = await Api(
        EndPoints.listPersonaActividadEconomica + "/" + codigoPersona,
        "GET",
        null
      )
      setActividades(response)
      setLoading(false)
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    }
  };

  const saveSocio = async () => {
    setIsSaving(true)
    try {
      const response = await Api(
        `${EndPoints.saveSocio}/${getCodigoIfip()}/${codigoPersona}`,
        'POST',
        null,
      )

      downloadBase64PDF(response.documentoGenerado.reportePdf, `registro_socio_${codigoPersona}`);
      enqueueSnackbar("Grabado correctamente", { variant: "success" })
      navigate('/home/socio')
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    } finally {
      setIsSaving(false)
    }
  }

  useEffect(() => {
    getListaActividades();
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} position="relative">
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} component={Typography} variant="h5">
                Agregar actividad económica
              </Grid>
              <Grid item xs={12}>
                <AgregarActividadSection
                  disabled={isSaving}
                  onSubmitted={getListaActividades}
                />
              </Grid>
              <Grid item xs={12} component={Typography} variant="h5">
                Actividades económicas agregadas
              </Grid>
              <Grid item xs={12}>
                <ListaActividades
                  actividades={actividades}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions
            classes={{
              root: classes.cardActions
            }}
          >
            <Button
              color="primary"
              onClick={goPreviousStep}
              disabled={isSaving}
            >
              Atrás
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              loading={isSaving}
              startIcon={
                <SaveAltIcon />
              }
              onClick={saveSocio}
            >
              <span>Finalizar e Imprimir</span>
            </LoadingButton>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ActividadEconomica;
